var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1320_20683",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4978 1.27734H0.640625V24.1345H23.4978V1.27734Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1320_20683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7538 4.13477H3.38237C2.18808 4.13477 1.22179 5.09905 1.22179 6.27762L1.21094 19.1348C1.21094 20.3134 2.18808 21.2776 3.38237 21.2776H20.7538C21.9481 21.2776 22.9252 20.3134 22.9252 19.1348V6.27762C22.9252 5.09905 21.9481 4.13477 20.7538 4.13477ZM20.7538 8.42048L12.0681 13.7776L3.38237 8.42048V6.27762L12.0681 11.6348L20.7538 6.27762V8.42048Z",
    fill: "#0091EA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAction);
export default __webpack_public_path__ + "static/media/emailAction.dfd822714b660fbfe4eb63aa324cab00.svg";
export { ForwardRef as ReactComponent };